import axios from "axios";

const LocationBasedDutyTypeService = {
  // Pass dutyType = null/"" for "All" 
  // pass a specific value to filter.
  async getAll(date, dutyType) {
    try {
      // Backend expects dutyType param always present — empty for "All"
      const url = `/UserDetails/GetAttendenceDetailsForDay?today=${date}&dutyType=${dutyType ? encodeURIComponent(dutyType) : ""}`;

      const response = await axios.get(url);

      console.log("DutyType-filtered API response:", response.data);

      if (response.data && Array.isArray(response.data.resultSet)) {
        return response.data.resultSet.map(item => ({
          Emp_location: item.location,
          Emp_Total: item.TotalEmp,
          Emp_real: item.TodayAtt,
          Percentage: item.Percentage,
          location: item.location,
          TotalEmp: item.TotalEmp,
          TodayAtt: item.TodayAtt,
        }));
      } else {
        console.warn("Unexpected API response structure:", response.data);
        return [];
      }
    } catch (error) {
      console.error("Error fetching duty-type-filtered location data:", error);
      throw error;
    }
  },
}

export default LocationBasedDutyTypeService;